import { StateCreator } from 'zustand'
import { Key } from 'react'
import { DataType, MasterStore, TableType } from '../../@types/store'

const createMasterSlice: StateCreator<
  MasterStore,
  [["zustand/devtools", never]],
  [],
  MasterStore
> = (set) => ({
  isDirty: false,
  loading: false,
  elementLoading: false,
  masterTables: [],
  activeKey: "",
  activeTab: "",
  filters: "",
  setIsDirty: (isDirty: boolean) => set(() => ({ isDirty: isDirty }), false, 'setIsDirty'),
  setLoading: (loading: boolean) => set(() => ({ loading: loading }), false, 'setLoading'),
  setElementLoading: (elementLoading: boolean) => set(() => ({ elementLoading: elementLoading }), false, 'setElementLoading'),
  setActiveKey: (key: string) => set(() => ({ activeKey: key }), false, 'setActiveKey'),
  setActiveTab: (key: string) => set(() => ({ activeTab: key }), false, 'setActiveTab'),
  setFilters: (filters: string) => set(() => ({ filters: filters }), false, 'setFilters'),
  setMasterTables: (data: DataType[]) => set(() => ({ masterTables: data }), false, 'setMasterTables'),
  setMasterData: (data: TableType, tableKey: string) => set((state) => ({
    masterTables:
      state.masterTables.map((table) =>
        table.key === tableKey ? { ...table, data: data } : table
      ),
  }), false, 'setMasterData'),
  setMasterElement: (element: object, tableKey: string) => set((state) => ({
    masterTables:
      state.masterTables.map((table) =>
        table.key === tableKey ? { ...table, data: { ...table.data, data: [...table.data.data, element] } } : table
      ),
  }), false, 'setMasterElement'),
  removeMasterElement: (tableKey: string, ids: Key[]) => set((state) => ({
    masterTables:
      state.masterTables.map((table) =>
        table.key === tableKey ? { ...table, data: { ...table.data, data: table.data.data.filter(d => !ids.includes(d.key)) } } : table
      ),
  }), false, 'removeMasterElement'),
  editMasterElement: (element: object, id: Key, tableKey: string) => set((state) => ({
    masterTables:
      state.masterTables.map((table) =>
        table.key === tableKey ? { ...table, data: { ...table.data, data: table.data.data.map(item => item.key === id ? { ...element, key: id } : item) } } : table
      ),
  }), false, 'editMasterElement'),
  setColumnFilters: (tableKey: string, column: string, values: object[]) => set((state) => ({
    masterTables:
      state.masterTables.map((table) =>
        table.key === tableKey ? { ...table, data: { ...table.data, columns: table.data.columns.map(item => item.dataIndex === column ? { ...item, values: values } : item) } } : table
      ),
  }), false, 'setColumnFilters')
})

export default createMasterSlice
